<template>
    <div id="user-edit-tab-info">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex items-start flex-col sm:flex-row">
                    <img v-if="base.information.photo" :src="base.information.photo" class="mr-8 rounded h-32 w-32" />
                    <img v-if="!base.information.photo" :src="avatar" class="mr-8 rounded h-32 w-32" />
                    <div>
                        <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{base.information.name}} {{base.information.first_name}}</p>
                        <h6 class="mb-3">{{base.information.customer}}</h6>
                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg"  accept="image/*">

                        <vs-button class="mr-4 mb-4" @click="$refs.updateImgInput.click()">Changer d'avatar</vs-button>

                        <vs-button type="border" color="danger" @click="avatar = null, users_delete_avatar()">Supprimer mon avatar</vs-button>
                        <p v-if="error.avatar"><span style="color: red">{{ error.avatar ? error.avatar[0] : ''}}</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                <p class="mt-5" >Nom <b style="color: #ff6141">*</b> </p>
                <vs-input 
                    autocomplete="off"
                    @keyup.enter="submitForm()"
                    :danger="error.name ? true : false"
                    :danger-text="error.name ? error.name[0] : ''"
                    class="w-full mt-4" v-model="base.input.name" name="last_name" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <p class="mt-5" >Prénom <b style="color: #ff6141">*</b> </p>
                <vs-input 
                    autocomplete="off"
                    @keyup.enter="submitForm()"
                    :danger="error.first_name ? true : false"
                    :danger-text="error.first_name ? error.first_name[0] : ''"
                    class="w-full mt-4" v-model="base.input.first_name" name="first_name" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <p class="mt-5" >Adresse e-mail <b style="color: #ff6141">*</b> </p>
                <vs-input
                    autocomplete="off"
                    @keyup.enter="submitForm()"
                    :danger="error.email ? true : false"
                    :danger-text="error.email ? error.email[0] : ''"
                    type="email" class="w-full mt-4" v-model="base.input.email" name="email" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <p class="mt-5" >Numéro de téléphone <b style="color: #ff6141">*</b> </p>
                <vs-input 
                    autocomplete="off"
                    @keyup.enter="submitForm()"
                    :danger="error.phone ? true : false"
                    :danger-text="error.phone ? error.phone[0] : ''"
                    class="w-full mt-4" v-model="base.input.phone" name="phone" />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="submitForm">Enregistrer</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var base_self;
    export default {
        data() {
            return {
                error:[],
                avatar: require('@/assets/images/avatar.png'),
                avatar_input: ''
            }
        },
        
        computed: {
            base () {
                return window.ProfileApp;
            }
        },
        methods: {
            async users_change_avatar () {
                base_self.$vs.loading()
                var form = new FormData()
                form.append('avatar', this.avatar_input);
                window.GETCCMT.$http.post('/users/change-avatar', form)
                    .then((response) => {
                        window.GETCCMT.success('La photo de profil est changée avec succès.', response);
                        base_self.$vs.loading.close()
                        let user = response.data.user
                        user.displayName = response.data.user.name;
                        user.userRole = response.data.user.profile;
                        user.company = response.data.user.customer;
                        user.photoURL = response.data.user.photo;
                        window.GETCCMT.$store.dispatch('updateUserInfo', user);
                        base_self.error = []
                        window.location.reload()
                    })
                    .catch((error) => {
                        base_self.$vs.loading.close()
                        if (error.response.status === 401){
                            window.GETCCMT.$router.push('/login')
                        }else {
                            base_self.error = error.response.data.errors
                        }
                    });
            },
            async users_delete_avatar () {
                base_self.$vs.loading()
                let response = await base_self.$store.state.users_delete_avatar({});
                if (response.data.status) {
                    base_self.$vs.loading.close()
                    window.GETCCMT.success('La photo de profil est supprimée avec succès.', response);
                    let user = response.data.user
                    user.displayName = response.data.user.name;
                    user.userRole = response.data.user.profile;
                    user.company = response.data.user.customer;
                    user.photoURL = response.data.user.photo;
                    window.GETCCMT.$store.dispatch('updateUserInfo', user);
                    window.location.reload()
                } else {
                    base_self.$vs.loading.close()
                    window.GETCCMT.error({ message: 'La suppression de la photo de profil a échouée.' });
                }
            },
            async submitForm() {
                base_self.$vs.loading()
                window.GETCCMT.$http.post('/users/update-information', base_self.base.input)
                    .then((response) => {
                        window.GETCCMT.success('Vos informations personnels ont étée modifier avec succès.', response);
                        let user = response.data.user
                        user.displayName = response.data.user.name;
                        user.userRole = response.data.user.profile;
                        user.company = response.data.user.customer;
                        user.photoURL = response.data.user.photo;
                        window.GETCCMT.$store.dispatch('updateUserInfo', user);
                        //base_self.base.users_information();
                        base_self.error = []
                        base_self.$vs.loading.close()
                        window.location.reload()
                    })
                    .catch((error) => {
                        base_self.$vs.loading.close()
                        if (error.response.status === 401){
                            window.GETCCMT.$router.push('/login')
                        }else {
                            base_self.error = error.response.data.errors
                        }
                    });
            },
            updateCurrImg(input) {
                if (input.target.files && input.target.files[0]) {
                    var reader = new FileReader();
                    reader.onload = e => {
                        this.avatar = e.target.result
                        this.avatar_input = base_self.$refs.updateImgInput.files[0];
                        this.users_change_avatar();
                    };
                    reader.readAsDataURL(input.target.files[0])
                }
                
            },
        },
        created() {
            base_self = this;
            window.UserEditTabAccountApp = this;
        }
    }
</script>